export default __webpack_public_path__ + "static/media/5.8ffac8a2.png";